<div class="order-sub-title">
  <p>{{subTitleText}}</p>
</div>
